import { Component, OnInit } from '@angular/core';
import { PageService } from '@services/page.service';
import { ViewService } from '@services/view.service';
import { PollService } from '@services/poll.service';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import * as _ from 'lodash';
import { fadeInLeftOnEnterAnimation } from 'angular-animations';
@Component({
  selector: 'app-get-started',
  templateUrl: './get-started.component.html',
  styleUrls: ['./get-started.component.sass']
})
export class GetStartedComponent implements OnInit {
  application = "poll";
  component = 'm';
  params: any = [];
  id = "";
  response: any = [];
  questions: any = [];
  answers: any = {};
  question_no = 0;
  total_question = 0;
  btn_show: any = {};
  questionids:any=[];
  pollJson:any=[];
  pollId='51254c89-f73f-332c-8c56-e6a570c7671c';
  ans=[];
  constructor(private _pollervice: PollService,private _viewService: ViewService,private _pageService: PageService,private route: ActivatedRoute, private _global: GlobalService) {
    
    let p={
      component:this.component,
      application:this.application,
      id:this.pollId
    };
    this._viewService.application(p).subscribe(
      pageData => {
        if (this._global.getVal(pageData, 'response', '')) {
          this.response = this._global.getVal(pageData, 'response', {});
          this.pollJson=this.response['pollJson'];
          this.questions=this.response['pollJson']['questions'];
          console.log(this.questions)
          this.total_question = this._global.getVal(this.pollJson,'numQuestions',0);
          if (this.total_question == 1) {
            this.btn_show['submit'] = true;
          } else if (this.total_question > 1) {
            this.btn_show['next'] = true;
          }
          
          console.log("total question",this.total_question)
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }

  ngOnInit() {
  }
  nextQuestion() {

    console.log(this.question_no,this.questionids[this.question_no])
    this.pollVote(this.questionids[this.question_no],this.ans[this.question_no])
    this.btn_show['submit'] = false;
    if (this.total_question > (this.question_no + 1)) {
      this.question_no += 1;
      this.btn_show['prev'] = true;
    } else {
      this.btn_show['prev'] = false;
      this.btn_show['next'] = false;
    }
    if (this.total_question == this.question_no + 1) {
      this.btn_show['submit'] = true;
      this.btn_show['next'] = false;
    }

    console.log("snabvdvsabdv",this.ans)
  }
  previousQuestion() {
    this.btn_show['submit'] = false;
    if (this.question_no > 0) {
      this.question_no -= 1;
      this.btn_show['next'] = true;
    } else {
      this.btn_show['prev'] = false;
      this.btn_show['next'] = true;
    }
    if (this.question_no == 0) {
      this.btn_show['prev'] = false;
    }
  }

  send() {
    console.log(this.question_no,this.questionids[this.question_no])
    this.pollVote(this.questionids[this.question_no],this.ans[this.question_no])
   /*  let final ={};
    Object.entries(this.questions).forEach(([key, value]) => {
      final[key] = {
        title: value['title']
      }
      let ans = [];
      Object.entries(value['a']).forEach(([key, value]) => {
        if (value['isChecked']) {
          ans.push(value['value'])
        }
      });
      final[key]['value'] = ans.join(",");

    });
    console.log("final", final)
    this.answers = final;
    console.log("dfdsnfnds",JSON.stringify(this.answers)) */
  }
  result(){
    let p={
      component:this.component,
      application:this.application,
      id:this.pollId
    };
    this._pollervice.result(p).subscribe(
      vote => {
        
        
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }

  pollVote(qid,aid){
    if(qid && aid){
    let p={
      component:this.component,
      application:this.application,
      pollId:this.pollId,
      questionId:qid,
      answerId:aid
    };
    this._pollervice.vote(p).subscribe(
      vote => {
        
        
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
    }
  }

}
